/**
 * Where the marketing site sends visitors when they click "Sign in".
 *
 * - Dev: the local Vite dev server for the main app (5173).
 * - Prod: the public app subdomain. Update this to your real value
 *         when you finalize the production hostname (e.g. app.boomshift.com).
 */
const DEV_APP_URL = 'http://localhost:5173'
const PROD_APP_URL = 'https://app.boomshift.com'

export const APP_URL = import.meta.env.PROD ? PROD_APP_URL : DEV_APP_URL

export const APP_ROUTES = {
  login: `${APP_URL}/login`,
  /**
   * Self-serve signup is not open yet — when it ships, point this at
   * the real route (e.g. `/register`). Until then it falls back to login
   * so any errant click still lands somewhere usable.
   */
  signup: `${APP_URL}/login`,
}

/**
 * Marketing copy constants that show up in more than one section,
 * kept here so the message is consistent without prop-drilling.
 */
export const SITE = {
  brand: 'Boomshift',
  tagline: 'Your trainer. Your plan. In one place.',
  status: 'Currently in private beta',
} as const
